import Vue from 'vue'
import App from './App.vue'
import router from './router'
import VueSlideUpDown from 'vue-slide-up-down'
import VueToast from 'vue-toast-notification'
import VueConfirmDialog from "vue-confirm-dialog";
import Modal from "@burhanahmeed/vue-modal-2";
import { store } from './store/store'
import Vue2TouchEvents from 'vue2-touch-events'
import vSelect from 'vue-select'

import './plugins/axios'

import 'bootstrap'
import 'bootstrap/dist/css/bootstrap.css'
import './assets/fontawesome-free-5.15.4-web/css/all.min.css'
import './assets/css/animate.css'
import './assets/css/style.css'
import './assets/css/admin.css'
import 'vue-toast-notification/dist/theme-sugar.css';
import '@desislavsd/vue-select/dist/vue-select.css'
import 'vue-select/dist/vue-select.css';


Vue.use(VueToast);

Vue.use(Modal, {
  componentName: "ModalVue"
});

Vue.use(VueConfirmDialog);
Vue.component('vue-confirm-dialog', VueConfirmDialog.default)

Vue.component('vue-slide-up-down', VueSlideUpDown)

Vue.component('v-select', vSelect)


Vue.config.productionTip = false;
Vue.config.devtools = true;
Vue.use(Vue2TouchEvents);

var data = {user: {name:''},barcodeListExists: false};

new Vue({
	store:store,
  router,
  data,
  render: h => h(App),
}).$mount('#app')